import { useEffect, useState } from "react";

/**
 * Hotkeys pentru help:
 * - F1: open help
 * - Esc: close help
 *
 * Optional: enabled=false dacă vrei să-l dezactivezi temporar.
 */
export function useHelpHotkey({ enabled = true } = {}) {
  const [showHelp, setShowHelp] = useState(false);

  useEffect(() => {
    if (!enabled) return;

    const onKeyDown = (e) => {
      if (e.key === "F1") {
        e.preventDefault(); // oprește help-ul browserului
        setShowHelp(true);
      }
      if (e.key === "Escape") {
        setShowHelp(false);
      }
    };

    // capture: true ajută când focusul e în componente care "înghit" keydown
    document.addEventListener("keydown", onKeyDown, { capture: true });
    return () =>
      document.removeEventListener("keydown", onKeyDown, { capture: true });
  }, [enabled]);

  return { showHelp, setShowHelp };
}
